import { Stack } from '@mui/joy';
import type { ReactElement } from 'react';
import GLink from '../GLink/GLink';
import { useApplication } from 'ApplicationContext';

export const SidebarTop = (): ReactElement => {
  const { Logo } = useApplication();
  return (
    <Stack justifyContent="center" width="100%" direction="row" p={1} spacing={1.5}>
      <GLink to="/app">
        <Logo width="6rem" />
      </GLink>
    </Stack>
  );
};
